import * as React from 'react';
import UTIF from 'utif2';
import Styles from '../assets/style.scss';
import ITiffViewerProps from '../entities/TiffViewer/ITiffViewerProps';
import { createGuid } from '@bimser/core';
import BCScrollbars from '../../BCScrollbars';

export default class TiffViewer extends React.Component<ITiffViewerProps, {}> {
	id: string;
	constructor(props: ITiffViewerProps) {
		super(props);
		this.id = createGuid();
	}

	componentDidMount() {
		let pages;
		let page;
		let resp;
		const loadCanvas = () => {
			UTIF.decodeImage(resp, pages[page]);
			const rgba = UTIF.toRGBA8(pages[page]);
			const canvas = document.createElement('canvas');
			canvas.width = pages[page].width;
			canvas.height = pages[page].height;
			const ctx = canvas.getContext('2d');
			const imageData = ctx.createImageData(canvas.width, canvas.height);
			for (let i = 0; i < rgba.length; i++) {
				imageData.data[i] = rgba[i];
			}
			ctx.putImageData(imageData, 0, 0);
			document.getElementById(this.id).append(canvas);

			if (++page < pages.length) {
				loadCanvas();
			}
		};

		const loaded = e => {
			resp = e.target.response;
			pages = UTIF.decode(resp);
			page = 0;
			loadCanvas();
		};

		const xhr = new XMLHttpRequest();
		xhr.open('GET', this.props.src);
		xhr.responseType = 'arraybuffer';
		xhr.onload = loaded;
		xhr.send();
	}

	render() {
		return (
			<BCScrollbars>
				<div
					id={this.id}
					className={Styles.tiffViewerContent}
				></div>
			</BCScrollbars>
		);
	}
}
